import script from "./SsoButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./SsoButtons.vue?vue&type=script&setup=true&lang=js"

import "./SsoButtons.vue?vue&type=style&index=0&id=6b0835c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b0835c2"]])

export default __exports__